export const CLIENT_VERSION = "0.1.0";

/**
 * Server URL resolution:
 * - `VITE_SERVER_URL` wins when set.
 * - In production the client is served by the game server, so use same origin.
 * - In dev, the Colyseus server runs on :2567.
 */
export function resolveServerUrl(): string {
  const fromEnv = import.meta.env.VITE_SERVER_URL as string | undefined;
  if (fromEnv) return fromEnv;
  if (import.meta.env.PROD && typeof window !== "undefined") {
    return window.location.origin;
  }
  return "ws://localhost:2567";
}

export const STORAGE_KEYS = {
  token: "agency.playerToken",
  nickname: "agency.nickname",
  avatarId: "agency.avatarId",
  muted: "agency.muted",
  radioVolume: "agency.radioVolume",
  radioMirrors: "agency.radioMirrors",
} as const;
